import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'content-interaction-bar',
  name: '内容互动栏',
  icon: '互',
  group: '详情通用组件',
  description: '点赞、评论、收藏、分享和关注操作。',
  defaultProps: {
    showLike: true,
    showComment: true,
    showFavorite: true,
    showShare: true,
    showFollow: true,
    sticky: true
  }
}
